import React from 'react';

interface LoadingModalProps {
  isOpen: boolean;
  title?: string;
  message?: string;
  progress?: number;
  showProgress?: boolean;
}

const LoadingModal: React.FC<LoadingModalProps> = ({
  isOpen,
  title = "Processing...",
  message = "Please wait while we process your request.",
  progress = 0,
  showProgress = false
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4 shadow-xl">
        <div className="text-center">
          {/* Spinning loader */}
          <div className="animate-spin rounded-full h-16 w-16 border-4 border-electric-blue border-t-transparent mx-auto mb-6"></div>
          
          {/* Title */}
          <h3 className="text-xl font-semibold text-gray-900 mb-2">{title}</h3>
          
          {/* Message */}
          <p className="text-gray-600 mb-4">{message}</p>
          
          {/* Progress bar (optional) */}
          {showProgress && (
            <div className="w-full bg-gray-200 rounded-full h-2 mb-4">
              <div 
                className="bg-electric-blue h-2 rounded-full transition-all duration-300"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
          )}
          
          {/* Progress percentage (optional) */}
          {showProgress && (
            <p className="text-sm text-gray-500">{Math.round(progress)}% complete</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoadingModal;